import SitecoreTextModel from '@models/SitecoreTextModel';

import SitecoreLinkModel from '../../../../../models/SitecoreLinkModel';

const TEXT_ARR = [
  'Description',
  'Section Title',
  'View All Button Text',
  'View details',
  'No Data Text',
  'Expire On Text',
  'Package count',
  'Store Label',
  'Sale Staff',
  'Total',
  'Order',
  'Load More Button Label'
];
const LINK_ARR = ['View Sale Order Detail Link'];

export default class CustomerSaleOrdersModel {
  constructor() {
    TEXT_ARR.forEach((item) => {
      this[item] = new SitecoreTextModel();
    });

    LINK_ARR.forEach((item) => {
      this[item] = new SitecoreLinkModel();
    });
  }

  getData(dataSource) {
    TEXT_ARR.forEach((item) => {
      if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, item)) {
        this[item].getData(dataSource[item]);
      }
    });

    LINK_ARR.forEach((item) => {
      if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, item)) {
        this[item].getData(dataSource[item]);
      }
    });

    return this;
  }
}
